











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TLeadsSearch, TLeadsPage, TLeadsForm } from '@/types/views/school';
import { getLeadsPage } from '@/api/school';
@Component({
  components: {
    Search: () => import('./components/search.vue'),
    List: () => import('./components/list.vue')
  }
})
export default class Leads extends Vue {
  private isFirstEnter = false;
  private shouldReset = false;
  private isClearQuickSearch = false;
  private options: TLeadsSearch = {
    pageSize: 20,
    currentPage: 1,
    phone: '',
    childName: '',
    firstCommStart: '',
    firstCommEnd: '',
    lastCommStart: '',
    lastCommEnd: '',
    nextCommStart: '',
    nextCommEnd: '',
    createTimeStart: '',
    createTimeEnd: '',
    saler: '',
    intention: '',
    dataStatus: '',
    isWxBinding: ''
  };
  private leadsPage: any;

  private beforeRouteEnter(to: any, from: any, next: any) {
    const backArr = ['leadsDetail'];
    if (backArr.includes(from.name)) {
      to.meta.isBack = true;
    }
  }
  private mounted() {
    this.isFirstEnter = true;
  }
  private activated() {
    // if (
    //   !this.$route.meta.isBack ||
    //   this.isFirstEnter ||
    //   Session.get('school-leads-list')
    // ) {
    //     Session.remove('school-leads-list');
    // }
    this.getLeadsPage();
    this.$route.meta.isBack = false;
    this.isFirstEnter = false;
  }
  private async getLeadsPage() {
    try {
      this.leadsPage = await getLeadsPage(this.options);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private handleOptions(opts: TLeadsForm) {
    this.options = { ...this.options, ...opts };
  }
  private handleReset() {
    this.shouldReset = !this.shouldReset;
  }
}
